<h3 class="ty-header">
    Thank you for registering!
</h3>

<p class="ty-info">
    You will receive a confirmation email shortly within the next 24 hours.
    If not, contact us at: <b>cvcfcontact@gmail.com</b>
    <br>
    Looking forward to seeing you there!
</p>

<!-- <p class="ty-info">
    <i class="fa fa-exclamation-circle fa-2x" style="color: #f04141"></i>
    <b>
        Please print a <a target="_blank"
            href="https://drive.google.com/file/d/1AeXlDdUbFpvNaMkoZmZr7CZ9dFQ4pan3/view?usp=sharing">Waiver Form</a>
        for each attendee to bring to camp.
    </b>
    <i class="fa fa-exclamation-circle fa-2x" style="color: #f04141"></i>
</p> -->


<div class="link-container">

    <a target="_blank" style="background-color: #3880ff" href="https://www.facebook.com/cvcfministry/">
        CVCF Facebook
    </a>

    <!-- <a target="_blank" style="background-color: #f04141"
        href="https://drive.google.com/file/d/1AeXlDdUbFpvNaMkoZmZr7CZ9dFQ4pan3/view?usp=sharing">
        Waiver Form
    </a> -->

    <a target="_blank" style="background-color: #10dc60" href="https://www.cvcfministry.org">
        CVCF Website
    </a>

    <a target="_blank" style="background-color: #e244e7ab; color: white;" (click)="navigateToForm()">
        Register More People
    </a>

    <a target="_blank" style="background-color: #e74444ab; color: white;" href="https://www.cvcfministry.org/give">
        Donate to Our Cause
    </a>

</div>

<!-- spacing -->
<div style="height: 50px;"></div>